import type { Enum } from './enum.types';

export const Order = {
  DESC: 'DESC',
  ASC: 'ASC',
} as const;
export type Order = Enum<typeof Order>;

export const LoadingStatus = {
  OK: 'OK',
  LOADING: 'LOADING',
  LOADING_MORE: 'LOADING_MORE',
  FINISHED: 'FINISHED',
  ERROR: 'ERROR',
} as const;
export type LoadingStatus = Enum<typeof LoadingStatus>;

export const PkTheme = {
  LIGHT: 'light',
  DARK: 'dark',
} as const;
export type PkTheme = Enum<typeof PkTheme>;

export const Keys = {
  ENTER: 'Enter',
  Tab: 'Tab',
  Space: ' ',
  LeftArrow: 'ArrowLeft',
  RightArrow: 'ArrowRight',
} as const;
